<template>
  <div class="home-container">
    <kaer-page
      :props="pageConfig"
      :customBack="true"
      @goBack="goBack"
    >
      <div
        class="back-to-top"
        v-if="pageConfig.showToTop"
        v-show="showBackTop"
        @click="goBackTop"
      ></div>

      <div
        class="rule-btn"
        v-if="pageConfig.ruleText"
        :style="{
          top: `${px2rem(pageConfig.ruleTop)}`
        }"
        @click="showRuleText = true"
        >
        <div class="rule-btn-inner">活动规则</div>
      </div>
      <van-popup v-model="showRuleText" class="rule-text-popup">
        <div class="rule-text-card">
          <div class="rule-text-header">活动规则</div>
          <div class="rule-text-content" v-html="pageConfig.ruleText && pageConfig.ruleText.replace(/\n|\r\n/g, '<br>')"></div>
        </div>
        <div class="rule-text-close" @click="showRuleText = false"></div>
      </van-popup>

      <!-- 解决外边距溢出问题 -->
      <table></table>
      <kaer-component @init="getPageData">
        <kaer-news-broadcast />
        <kaer-first-screen />
        <kaer-redpacket-card />
        <kaer-image-single />
        <kaer-extra-award />
      </kaer-component>
    </kaer-page>

    <Operate />
    <ToRetain :props="pageConfig" v-model="showToRetain" />

     <!-- 提前加载图片，防止海报生成图片加载失败 -->
    <img crossorigin="anonymous" :src="homeInfo.picture" hidden>
    <img crossorigin="anonymous" :src="pageConfig.toRetain" hidden>
  </div>
</template>
<script>
import qs from 'qs';
import { env } from '@/config';
import VueScrollTo from 'vue-scrollto';
import KaerImageSingle from '@/components/kaer-image-single';
import KaerNewsBroadcast from '@/components/kaer-news-broadcast';
import KaerFirstScreen from '@/components/kaer-first-screen';
import KaerRedpacketCard from '@/components/kaer-redpacket-card';
import KaerExtraAward from '@/components/kaer-extra-award';
import Operate from '@/components/operate';
import ToRetain from '@/components/to-retain';
import { mapState } from 'vuex';
import { px2rem } from '@/utils/utils';

export default {
  components: {
    KaerImageSingle,
    KaerNewsBroadcast,
    KaerFirstScreen,
    KaerRedpacketCard,
    KaerExtraAward,
    Operate,
    ToRetain
  },
  data() {
    return {
      pageConfig: {},
      shareConfig: {},
      headerConfig: {},
      opacity: 0,
      showBackTop: false,
      showRuleText: false,
      isMock: env === 'mock',
      showToRetain: false
    };
  },
  computed: {
    ...mapState({
      homeInfo: state => state.share.homeInfo,
      shareUrl: state => state.share.shareUrl
    }),
    rulePadding() {
      // 44 header高度 + 8 间距
      return this.adapt.getPaddingTop() + 108;
    },
    headerPaddingTop() {
      return this.adapt.getPaddingTop() + 44;
    }
  },
  methods: {
    px2rem,
    async getPageData(pageData) {
      if (!pageData.activityId) return this.$toast('页面未配置活动id');
      console.log('getPageData', pageData);
      this.pageConfig = pageData;
      this.shareConfig = pageData.headerConfig?.shareConfig || {};
      this.headerConfig = pageData.headerConfig || {};

      this.$store.commit('setPageData', pageData);
      this.$store.commit('setShareConfig', this.shareConfig);
      sessionStorage.setItem('shareConfig', JSON.stringify(this.shareConfig));

      // 活动下架
      if (pageData.showPage === false) {
        this.$dialog.alert({
          className: 'zy-custom-dialog',
          title: '抱歉，来晚了',
          message: '您查看的活动已结束。',
          confirmButtonText: '我知道了'
        }).then(() => {
          if (this.env.inWechatMiniProgram) {
            wx.miniProgram.navigateBack();
          } else {
            this.adapt.goBack();
          }
        });
      }

      pageData.headerConfig.title && this.adapt.setTitle(pageData.headerConfig.title);

      // 获取 主页信息
      await this.$store.dispatch('fetchHomeInfo', {
        bizId: 'C_TERMINAL',
        activityId: pageData.activityId
      });

      // 设置分享页地址
      const queryObj = {
        jumpWechatMPLogin: true, // 小程序登录后是否跳转到当前页
        extraLogin: 1,
        gitName: window.__kaer_config__.config?.gitName || ''
      };
      // 携带当前url参数， 过滤个别字段
      const blackList = ['activityId', 'user_token', 'telescope-info', 'encryptionUserId', 'inviterUserId'];
      Object.entries(this.$route.query).forEach(([key, val]) => {
        if (!blackList.includes(key)) {
          queryObj[key] = val;
        }
      });

      const keys = ['activityId', 'bizId', 'activityType', 'encryptionUserId', 'inviterUserId'];
      keys.forEach(key => {
        queryObj[key] = this.homeInfo[key];
      });

      const shareUrl = `${this.pageConfig.inviteesUrl.replace(/\.html.*$/, '.html#/')}?${qs.stringify(queryObj)}&useless=1`; // useless 防止链接被添加参数
      this.$store.commit('setShareUrl', shareUrl);

      const shareData = {
        title: this.shareConfig.title,
        content: this.shareConfig.content,
        link: shareUrl.includes('inviterUserId') ? shareUrl : window.location.href,
        imageUrl: this.shareConfig.imageUrl || 'http://static.91jkys.com/activity/img/d3a997de75364ca1a5d81ad9065d5567.png'
      };
      this.adapt.setShareConfig(shareData);

      // 设置小程序分享
      this.setMiniProgramShare();

      const pageId = window.__kaer_config__?.config?.pageId;
      this.uploadData(pageId || this.$teleCodes.homePage, 'page', {
        title: pageData.title,
        ...queryObj
      });
    },
    goBackTop() {
      VueScrollTo.scrollTo(document.getElementsByTagName('body')[0], 300);
    },
    setMiniProgramShare() {
      if (this.env.inWechatMiniProgram) {
        const shareConfig = {
          title: this.shareConfig.title,
          pageUrl: window.location.href,
          shareUrl: encodeURIComponent(this.shareUrl.includes('inviterUserId') ? this.shareUrl : window.location.href),
          imageUrl: encodeURIComponent(this.shareConfig.imageUrl || 'http://static.91jkys.com/activity/img/d3a997de75364ca1a5d81ad9065d5567.png')
          // isNeedLogin: 1, // 小程序默认 1
          // trackId: string 埋点id
        };
        wx.miniProgram.postMessage({ data: shareConfig });
      }
    },
    goBack() {
      if (+this.homeInfo.activityState === 2) {
        this.showToRetain = true;
      } else {
        this.$goBack();
      }
    }
  }
};
</script>
<style lang="less" scoped>
.home-container {
  width: 100%;
  position: relative;

  .back-to-top {
    width: 44px;
    height: 44px;
    background-image: url('~@/assets/back-top-icon.png');
    background-size: 100%;
    position: fixed;
    bottom: 80px;
    right: 12px;
    z-index: 99;
  }

  .rule-btn {
    position: absolute;
    right: 0;

    .rule-btn-inner {
      color: #fff;
      background-color: #262626;
      opacity: 0.8;
      border-radius: 9px 0 0 9px;
      height: 18px;
      line-height: 18px;
      font-size: 12px;
      padding: 0 8px;
      margin-top: 40Px;
    }
  }

  .rule-text-card {
    background-color: #fff;
    border-radius: 6px;
    width: 280px;
    padding: 20px;
    .rule-text-header {
      color: #262626;
      font-weight: 500;
      font-size: 14px;
      margin-bottom: 12px;
      text-align: center;
    }
    .rule-text-content {
      max-height: 260px;
      font-size: 12px;
      overflow-y: scroll;
    }
  }

  .rule-text-close {
    width: 28px;
    height: 28px;
    background-image: url('~@/assets/rule-close-icon.png');
    background-size: 100%;
    margin-top: 16px;
    margin-left: calc(50% - 14px);
  }

  /deep/ .kaer-page-container {
    padding-bottom: 56px;
  }
}

@supports (bottom: env(safe-area-inset-bottom)) {
  .home-container {
    .kaer-page-container {
      padding-bottom: calc(constant(safe-area-inset-bottom) + 56px) !important;
      padding-bottom: calc(env(safe-area-inset-bottom) + 56px) !important;
    }
  }
}

</style>
